/**
 * GHORBA CLUB — Personnalisateur POD
 * Fichier généré par tools/build-theme.js. Ne pas modifier à la main :
 * les sources sont dans shared/ et theme/ du dépôt ghorba-pod.
 */
(() => {
/* ---- shared/template-spec.js ---- */
/**
 * GHORBA CLUB — Spécification géométrique des templates POD
 * ---------------------------------------------------------
 * Source de vérité UNIQUE, partagée par :
 *   - l'aperçu temps réel dans le navigateur (theme/ghorba-pod.js)
 *   - le rendu haute définition côté serveur (server/index.js)
 * Toute valeur ici est exprimée dans l'espace « design » de 2000 × 2000 px,
 * repris tel quel des PSD (FW27/POD/*.psd). Le rendu applique un simple
 * facteur d'échelle : l'aperçu et le fichier imprimé sont donc identiques
 * au pixel près, à la résolution près.
 *
 * Les valeurs proviennent d'une extraction automatique des calques PSD
 * (bbox d'encre, couleurs médianes, angles mesurés sur les quadrilatères).
 */

const DESIGN_SIZE = 2000;

/** Polices — les fichiers vivent dans assets/fonts/ */
const FONTS = {
  FatboySlim: {
    family: 'FatboySlimBLTC',
    woff2: 'FatboySlimBLTC2BRK.woff2',
    ttf: 'FatboySlimBLTC2BRK.ttf',
  },
  Gambarino: {
    family: 'Gambarino',
    woff2: 'Gambarino-Regular.woff2',
    ttf: 'Gambarino-Regular.otf',
  },
  /**
   * Le nom sur la carte de séjour est en Arial Bold dans le PSD. Arial ne se
   * diffuse pas sur le web, et n'existe pas sur Android : le nom du client
   * serait rendu dans une autre police que celle du gabarit. Arimo a les
   * mêmes chasses au dixième près (« THIERRY HENRI » mesure 319,9 px contre
   * 319,1 pour Arial) et se diffuse librement.
   */
  Arimo: {
    family: 'ArimoBold',
    woff2: 'Arimo-Bold.woff2',
    ttf: 'Arimo-Bold.ttf',
  },
};

/**
 * Zone d'impression Printful DTG « front large » : 12 × 16 pouces à 300 dpi.
 * On exporte TOUJOURS à cette taille, design déjà positionné, fond transparent.
 * Conséquence pratique : dans Printful tu remplaces le fichier et le placement
 * ne bouge pas d'un millimètre — aucun réglage manuel à refaire.
 */
const PRINT_AREA = {
  widthIn: 12,
  heightIn: 16,
  dpi: 300,
  get widthPx() { return this.widthIn * this.dpi; },   // 3600
  get heightPx() { return this.heightIn * this.dpi; }, // 4800
  /** Position verticale du haut du design, en % de la hauteur de zone.
   *  0.14 place le visuel au milieu de la poitrine sur une coupe standard. */
  topOffsetRatio: 0.14,
};

/**
 * Mockups Stanley/Stella oversize, tels que fournis par Printful.
 * L'aperçu client se compose directement dessus : il voit le vêtement,
 * pas un carré flottant.
 *
 * `printBox` est la zone d'impression 12 × 16 po reportée sur l'image du
 * mockup, en fractions de sa largeur/hauteur. Elle a été calée en comparant
 * un mockup Printful rendu avec design à sa version vierge — le design
 * retombe donc exactement là où Printful le place réellement.
 */
const MOCKUPS = {
  noir:  { id: 'noir',  label: 'Noir',  asset: 'tee-noir.png',  dark: true },
  blanc: { id: 'blanc', label: 'Blanc', asset: 'tee-blanc.png', dark: false },
};

const MOCKUP_PRINT_BOX = { x: 0.2875, y: 0.19375, w: 0.4225, h: 0.5638 };

const TEMPLATES = {
  /* ------------------------------------------------------------------ *
   *  A — Polaroid, une seule photo (PSD : « template pod 02 une image »)
   * ------------------------------------------------------------------ */
  A: {
    id: 'A',
    /** Nom court affiche sur la tuile, et note sous le nom. */
    name: 'Polaroid',
    note: 'Une seule photo',
    /** Libelle repris dans la propriete de ligne de panier. */
    label: 'Polaroid, 1 photo',
    photoCount: 1,

    /**
     * Ce qu'on montre dans « Choisis ton modele » tant que le client n'a
     * rien depose. Un cadre vide ne dit rien du produit : l'exemple, lui,
     * montre le cadrage reel et, pour le duo, le trombone.
     */
    example: {
      photos: { photo1: 'exemple-1.jpg' },
      crops: { photo1: { zoom: 1, dx: 0, dy: -0.15 } },
      caption: 'Lost in ghorba',
    },

    /** Le « papier » polaroid : il s'imprime, donc il est bien visible
     *  sur un t-shirt foncé. Sur un t-shirt écru il se fondra presque. */
    frame: { x: 463, y: 306, w: 1074, h: 1387, fill: '#FDFCF1' },

    slots: [
      { id: 'photo1', x: 508, y: 409, w: 984, h: 1043, rotation: 0 },
    ],

    /** Textes de marque — non modifiables par le client.
     *  Justifiés aux deux extrémités : GHORBA à gauche, CLUB à droite. */
    staticTexts: [
      { id: 'brandL', text: 'GHORBA', font: 'Gambarino', size: 59,
        color: '#E52420', anchor: 'left',  x: 510,  inkBottom: 392 },
      { id: 'brandR', text: 'CLUB',   font: 'Gambarino', size: 59,
        color: '#E52420', anchor: 'right', x: 1486, inkBottom: 393 },
    ],

    /** LA phrase que le client peut réécrire, dans la typo de la marque. */
    editableText: {
      id: 'caption',
      /** Titre de l'étape et légende du champ. */
      label: 'Ta phrase',
      default: 'Lost in ghorba',
      font: 'FatboySlim',
      size: 110,
      color: '#CC1517',
      anchor: 'center',
      cx: 984.5,
      inkBottom: 1593,
      maxWidth: 921,
      maxChars: 28,
    },

    overlays: [],

    /** Zone réellement encrée : c'est elle qu'on met à l'échelle physique. */
    trim: { x: 463, y: 306, w: 1074, h: 1387 },
    /** Largeur d'impression visée sur le t-shirt. Ajuste ici après ton
     *  premier échantillon imprimé — rien d'autre à toucher.
     *  8,5 cm de large donne 11 cm de haut : les proportions exactes d'un
     *  vrai Polaroid, et un impact visuel équivalent au modèle Duo. */
    printWidthCm: 8.5,
  },

  /* ------------------------------------------------------------------ *
   *  B — Deux photos + trombone (PSD : « template pod 01 deux image »)
   * ------------------------------------------------------------------ */
  B: {
    id: 'B',
    name: 'Duo au trombone',
    note: 'Deux photos',
    label: 'Duo au trombone, 2 photos',
    photoCount: 2,

    example: {
      photos: { photo1: 'exemple-1.jpg', photo2: 'exemple-2.jpg' },
      crops: { photo1: { zoom: 1, dx: 0, dy: -0.1 }, photo2: { zoom: 1.1, dx: 0, dy: 0 } },
      caption: 'Lost in ghorba',
    },

    /** Pas de cadre : les photos sont posées à même le tissu. */
    frame: null,

    slots: [
      { id: 'photo1', x: 266, y: 473, w: 751, h: 832, rotation: 0 },
      // Photo de droite : légèrement redressée vers la gauche.
      // Angle moyenné sur les 4 arêtes du quadrilatère mesuré.
      { id: 'photo2', x: 947.5, y: 480, w: 755, h: 790, rotation: -3.7 },
    ],

    staticTexts: [],

    editableText: {
      id: 'caption',
      /** Titre de l'étape et légende du champ. */
      label: 'Ta phrase',
      default: 'Lost in ghorba',
      font: 'FatboySlim',
      size: 112,
      color: '#000000',
      /** Le texte est posé à même le tissu : en noir il disparaîtrait sur un
       *  t-shirt sombre. On bascule sur le crème du papier polaroid, plus
       *  doux qu'un blanc pur et cohérent avec le modèle A. */
      colorOnDark: '#FDFCF1',
      anchor: 'center',
      cx: 1019.5,
      inkBottom: 1489,
      maxWidth: 931,
      maxChars: 28,
    },

    /** Le trombone se dessine PAR-DESSUS les deux photos. */
    overlays: [
      { id: 'clip', asset: 'trombone.png', x: 918, y: 409, w: 132, h: 301 },
    ],

    trim: { x: 266, y: 409, w: 1467, h: 1080 },
    printWidthCm: 11,
  },

  /* ------------------------------------------------------------------ *
   *  C — Carte de séjour (PSD : « template carte de sejpur »)
   * ------------------------------------------------------------------ *
   *  Une seule photo, un seul champ : le nom. Tout le reste de la carte
   *  — la date, le numéro, la signature GHORBA CLUB — est fixe et vit
   *  dans l'image de fond.
   *
   *  Cette image de fond est extraite du PSD par `tools/extraire-carte.py`,
   *  qui en retire la photo d'exemple et la ligne du nom. Toute retouche du
   *  PSD se répercute donc en une commande, sans recopier une valeur.
   */
  C: {
    id: 'C',
    name: 'Carte de séjour',
    note: 'Une photo et ton nom',
    label: 'Carte de séjour, 1 photo',
    photoCount: 1,

    example: {
      photos: { photo1: 'exemple-1.jpg' },
      crops: { photo1: { zoom: 1, dx: 0, dy: -0.1 } },
      caption: 'NOM PRENOM',
    },

    /** La carte entière, tout sauf la photo et le nom. */
    frame: { asset: 'carte-fond.webp', x: 181, y: 484, w: 1638, h: 1028 },

    /**
     * La photo se fond dans la carte au lieu de se poser dessus : en
     * « obscurcir », le guillochage et le relief du support traversent
     * l'image, comme sur un vrai titre. C'est le mode retenu dans le PSD.
     */
    slots: [
      { id: 'photo1', x: 220, y: 763, w: 557, h: 716, rotation: 0, blend: 'darken' },
    ],

    staticTexts: [],

    /**
     * Le nom, sur la ligne « NOM Prénoms / SURNAME Forenames ».
     * Relevé du calque texte du PSD : Arial Bold 41,67 px, noir, fusion
     * « produit » à 90 %, aligné à gauche sur x = 817, encre calée sur
     * y = 817. Les majuscules sont imposées, comme sur le document.
     */
    editableText: {
      id: 'caption',
      /** Titre de l'étape et légende du champ. */
      label: 'Ton nom',
      hint: "Il passe en majuscules, comme sur le vrai document.",
      /** Affiché tant que le client n'a rien tapé — jamais imprimé. */
      default: 'NOM PRENOM',
      /** Sans nom, la carte n'a pas de sens : on ne laisse pas partir. */
      required: true,
      transform: 'uppercase',
      font: 'Arimo',
      size: 41.67,
      color: '#000000',
      blend: 'multiply',
      opacity: 0.902,
      anchor: 'left',
      x: 817,
      inkBottom: 817,
      maxWidth: 900,
      maxChars: 30,
    },

    overlays: [],

    trim: { x: 181, y: 484, w: 1638, h: 1028 },
    /**
     * Relevé sur le mockup Printful du produit, par
     * `node tools/placement-printful.js carte` : la carte fait 15,3 cm de
     * large, donc 9,6 de haut, à 272 dpi. Ce n'est pas une valeur choisie,
     * c'est le reflet du cadrage réglé dans Printful. Si tu y touches,
     * relance l'outil et reporte ce qu'il mesure.
     */
    printWidthCm: 15.3,
    /**
     * La carte est posée plus bas sur le torse que le polaroid : relevé sur
     * les mockups Printful du produit, noir et blanc donnent tous deux
     * 0,2479. Sans cette valeur, l'aperçu la montrait 123 px trop haut sur
     * un mockup de 2000, soit 4,4 cm de décalage sur le vêtement.
     * `node tools/placement-printful.js carte` refait la mesure.
     */
    topOffsetRatio: 0.248,
  },
};

/** Toutes les images de gabarit a precharger (fonds, sur-couches). */
const TEMPLATE_ASSETS = [...new Set(
  Object.values(TEMPLATES).flatMap(t => [
    t.frame?.asset,
    ...t.overlays.map(o => o.asset),
  ]).filter(Boolean)
)];

/** Tous les fichiers d'exemple a precharger, sans doublon. */
const EXAMPLE_ASSETS = [...new Set(
  Object.values(TEMPLATES).flatMap(t => Object.values(t.example?.photos || {}))
)];

/** Résolution utile (px/cm) d'un slot photo une fois imprimé au format visé. */
function slotPrintResolution(tpl, slot) {
  const pxPerDesignUnit = (tpl.printWidthCm > 0)
    ? tpl.trim.w / tpl.printWidthCm   // unités design par cm
    : 1;
  const slotCm = slot.w / pxPerDesignUnit;
  return { slotWidthCm: slotCm };
}

/**
 * Qualité d'une photo client pour un slot donné.
 * On ne bloque JAMAIS : on informe. Les photos d'enfance sont souvent
 * de vieux scans basse résolution, et c'est assumé par le produit.
 */
const QUALITY = {
  /** dpi effectif = pixels de la photo / taille imprimée en pouces */
  good: 200,      // ≥ 200 dpi : net
  ok: 120,        // 120–200 : correct, léger grain
  // < 120 dpi : visiblement pixellisé — on prévient explicitement
};

function assessPhoto(tpl, slot, imgW, imgH) {
  const unitsPerCm = tpl.trim.w / tpl.printWidthCm;
  const slotWcm = slot.w / unitsPerCm;
  const slotHcm = slot.h / unitsPerCm;
  // La photo est recadrée pour remplir le slot : c'est la dimension la plus
  // contrainte qui décide de la netteté finale.
  const scale = Math.max(slot.w / imgW, slot.h / imgH);
  const effW = imgW * scale, effH = imgH * scale;
  const dpi = Math.min(effW / (slotWcm / 2.54), effH / (slotHcm / 2.54));
  let level, message;
  if (dpi >= QUALITY.good) {
    level = 'good';
    message = 'Belle qualité, l\'impression sera nette.';
  } else if (dpi >= QUALITY.ok) {
    level = 'ok';
    message = 'Qualité correcte. Un léger grain restera visible, comme sur une vraie photo d\'époque.';
  } else {
    level = 'low';
    message = 'Cette photo est en basse résolution : elle sortira floue ou pixellisée à l\'impression. '
            + 'C\'est souvent le cas des vieilles photos. À toi de voir si ce grain te plaît.';
  }
  return { dpi: Math.round(dpi), level, message };
}


/* ---- shared/png-dpi.js ---- */
/**
 * Inscrit la résolution physique dans un PNG.
 *
 * Pourquoi c'est indispensable
 * ----------------------------
 * Un PNG peut déclarer combien de pixels valent un mètre, dans un bloc
 * nommé `pHYs`. Printful s'en sert pour décider de la taille du design sur
 * le vêtement. Sans ce bloc, il retombe sur 72 dpi : un fichier de 2000 px
 * est alors interprété comme 70 cm de large au lieu de 17, et le placement
 * est à refaire à la main à chaque commande.
 *
 * Ni le canevas du navigateur ni celui de Node n'écrivent ce bloc. On
 * l'ajoute donc nous-mêmes, juste après l'en-tête, comme le fait Photoshop.
 *
 * Ce module tourne des deux côtés : il ne manipule que des octets, sans
 * rien emprunter à Node ni au navigateur.
 */

const SIGNATURE = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
const INCH_PER_METRE = 39.3701;

/** Table de CRC-32, calculée une fois. */
const CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    table[n] = c >>> 0;
  }
  return table;
})();

function crc32(bytes) {
  let c = 0xffffffff;
  for (let i = 0; i < bytes.length; i++) c = CRC_TABLE[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
}

const toBytes = (data) =>
  data instanceof Uint8Array ? data : new Uint8Array(data);

const readU32 = (b, i) =>
  ((b[i] << 24) | (b[i + 1] << 16) | (b[i + 2] << 8) | b[i + 3]) >>> 0;

const writeU32 = (b, i, v) => {
  b[i] = (v >>> 24) & 0xff; b[i + 1] = (v >>> 16) & 0xff;
  b[i + 2] = (v >>> 8) & 0xff; b[i + 3] = v & 0xff;
};

const typeAt = (b, i) =>
  String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);

const isPng = (b) => SIGNATURE.every((v, i) => b[i] === v);

/** Assemble un bloc PNG : longueur, type, données, somme de contrôle. */
function makeChunk(type, data) {
  const out = new Uint8Array(12 + data.length);
  writeU32(out, 0, data.length);
  for (let i = 0; i < 4; i++) out[4 + i] = type.charCodeAt(i);
  out.set(data, 8);
  // La somme porte sur le type ET les données.
  writeU32(out, 8 + data.length, crc32(out.subarray(4, 8 + data.length)));
  return out;
}

/**
 * Renvoie une copie du PNG portant la résolution demandée.
 * Un bloc `pHYs` déjà présent est remplacé.
 *
 * @param {Uint8Array|ArrayBuffer|Buffer} png
 * @param {number} dpi  points par pouce (300 pour de l'impression)
 * @returns {Uint8Array}
 */
function setPngDpi(png, dpi = 300) {
  const bytes = toBytes(png);
  if (!isPng(bytes)) throw new Error('ce fichier n’est pas un PNG');

  const perMetre = Math.round(dpi * INCH_PER_METRE);
  const data = new Uint8Array(9);
  writeU32(data, 0, perMetre);  // axe horizontal
  writeU32(data, 4, perMetre);  // axe vertical
  data[8] = 1;                  // unité : le mètre
  const phys = makeChunk('pHYs', data);

  // On reconstruit le fichier bloc par bloc : insertion après l'en-tête
  // IHDR, et retrait d'un éventuel pHYs existant.
  const pieces = [bytes.subarray(0, 8)];
  let i = 8;
  let placed = false;

  while (i < bytes.length) {
    const length = readU32(bytes, i);
    const type = typeAt(bytes, i);
    const end = i + 12 + length;

    if (type !== 'pHYs') pieces.push(bytes.subarray(i, end));
    if (type === 'IHDR' && !placed) {
      pieces.push(phys);
      placed = true;
    }
    if (type === 'IEND') break;
    i = end;
  }

  const total = pieces.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let at = 0;
  for (const p of pieces) { out.set(p, at); at += p.length; }
  return out;
}

/** Lit la résolution déclarée, ou null si le PNG n'en porte pas. */
function getPngDpi(png) {
  const bytes = toBytes(png);
  if (!isPng(bytes)) return null;
  let i = 8;
  while (i < bytes.length) {
    const length = readU32(bytes, i);
    const type = typeAt(bytes, i);
    if (type === 'pHYs') {
      return bytes[i + 16] === 1
        ? Math.round(readU32(bytes, i + 8) / INCH_PER_METRE)
        : null;
    }
    if (type === 'IEND') return null;
    i += 12 + length;
  }
  return null;
}


/* ---- shared/renderer.js ---- */
/**
 * GHORBA CLUB — Moteur de rendu isomorphe
 * ---------------------------------------
 * Le MÊME code tourne dans le navigateur (aperçu temps réel) et dans Node
 * (@napi-rs/canvas, export 300 dpi). C'est la garantie que ce que le client
 * voit à l'écran est exactement ce qui part à l'impression.
 *
 * Il ne dépend que d'un CanvasRenderingContext2D et d'objets image déjà
 * décodés — aucun accès réseau, aucun accès disque.
 */

const INCHES_PER_CM = 1 / 2.54;

/* ------------------------------------------------------------------ */
/*  Texte ancré sur sa bbox d'encre                                    */
/* ------------------------------------------------------------------ */
/**
 * On positionne le texte d'après l'encre réellement dessinée, pas d'après
 * les métriques de la police. C'est ce qui permet de retomber exactement sur
 * le PSD, et de garder la phrase bien calée quoi que tape le client.
 */
function drawInkText(ctx, cfg, scale, textOverride, dark = false) {
  let text = (textOverride ?? cfg.text ?? cfg.default ?? '').trim();
  // Le nom d'une carte de sejour est en capitales sur le document : on
  // l'impose ici plutot que dans le champ, pour que l'apercu, le fichier
  // d'impression et la propriete de ligne de panier disent la meme chose.
  if (cfg.transform === 'uppercase') text = text.toUpperCase();
  if (!text) return;

  const family = FONTS[cfg.font].family;
  let size = cfg.size * scale;

  const measure = (s) => {
    ctx.font = `${s}px "${family}"`;
    const m = ctx.measureText(text);
    return {
      m,
      inkW: m.actualBoundingBoxLeft + m.actualBoundingBoxRight,
    };
  };

  let { m, inkW } = measure(size);

  // Le client peut écrire plus long que la phrase d'origine : on réduit
  // jusqu'à tenir dans la largeur du bloc, plutôt que de déborder.
  if (cfg.maxWidth) {
    const maxW = cfg.maxWidth * scale;
    if (inkW > maxW) {
      size = size * (maxW / inkW);
      ({ m, inkW } = measure(size));
    }
  }

  let drawX;
  if (cfg.anchor === 'left')       drawX = cfg.x * scale + m.actualBoundingBoxLeft;
  else if (cfg.anchor === 'right') drawX = cfg.x * scale - m.actualBoundingBoxRight;
  else                             drawX = cfg.cx * scale + (m.actualBoundingBoxLeft - m.actualBoundingBoxRight) / 2;

  const drawY = cfg.inkBottom * scale - m.actualBoundingBoxDescent;

  ctx.save();
  ctx.textAlign = 'left';
  ctx.textBaseline = 'alphabetic';
  // Repris du PSD quand le calque texte n'est pas en fusion normale : le nom
  // de la carte est en « produit » a 90 %, ce qui laisse le guillochage
  // transparaitre sous les lettres.
  if (cfg.blend) ctx.globalCompositeOperation = cfg.blend;
  if (cfg.opacity != null) ctx.globalAlpha = cfg.opacity;
  // Un texte posé à même le tissu doit rester lisible sur un coloris sombre.
  ctx.fillStyle = (dark && cfg.colorOnDark) ? cfg.colorOnDark : cfg.color;
  ctx.fillText(text, drawX, drawY);
  ctx.restore();
}

/* ------------------------------------------------------------------ */
/*  Photo dans un slot (recadrage « cover » + zoom + déplacement)       */
/* ------------------------------------------------------------------ */
/**
 * crop = { zoom = 1, dx = 0, dy = 0 }
 *   zoom : 1 = la photo remplit tout juste le slot ; > 1 = on zoome dedans
 *   dx / dy : déplacement dans [-1, 1], en fraction du débordement
 *             (0 = centré, -1 = collé à gauche/haut, 1 = à droite/bas)
 */
function drawSlot(ctx, slot, img, crop, scale) {
  if (!img) return;
  const c = { zoom: 1, dx: 0, dy: 0, ...(crop || {}) };

  const w = slot.w * scale;
  const h = slot.h * scale;
  const cx = (slot.x + slot.w / 2) * scale;
  const cy = (slot.y + slot.h / 2) * scale;

  ctx.save();
  ctx.translate(cx, cy);
  if (slot.rotation) ctx.rotate((slot.rotation * Math.PI) / 180);

  ctx.beginPath();
  ctx.rect(-w / 2, -h / 2, w, h);
  ctx.clip();

  const cover = Math.max(w / img.width, h / img.height);
  const z = cover * Math.max(1, c.zoom);
  const dw = img.width * z;
  const dh = img.height * z;
  const ox = ((dw - w) / 2) * clamp(c.dx, -1, 1);
  const oy = ((dh - h) / 2) * clamp(c.dy, -1, 1);

  ctx.imageSmoothingEnabled = true;
  if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';
  // La photo de la carte se fond dans le support en « obscurcir » : le
  // guillochage traverse l'image au lieu d'etre recouvert. Ailleurs, la
  // photo se pose normalement.
  if (slot.blend) ctx.globalCompositeOperation = slot.blend;
  ctx.drawImage(img, -dw / 2 - ox, -dh / 2 - oy, dw, dh);

  ctx.restore();
}

const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

/* ------------------------------------------------------------------ */
/*  Rendu complet d'un template dans l'espace design 2000 × 2000       */
/* ------------------------------------------------------------------ */
/**
 * @param ctx    contexte 2D déjà dimensionné à 2000*scale
 * @param tpl    entrée de TEMPLATES
 * @param state  { photos: {photo1: Image}, crops: {photo1: {...}}, caption: string }
 * @param opts   { scale, assets: { 'trombone.png': Image }, background, dark }
 *               `dark` = le design part sur un tissu sombre.
 */
function renderTemplate(ctx, tpl, state, opts) {
  const scale = opts.scale ?? 1;
  const assets = opts.assets ?? {};
  const dark = opts.dark ?? false;

  // Fond : transparent pour l'impression, blanc/tissu pour l'aperçu.
  if (opts.background) {
    ctx.fillStyle = opts.background;
    ctx.fillRect(0, 0, 2000 * scale, 2000 * scale);
  }

  // 1. Le fond du gabarit, sous les photos.
  //    Un aplat pour le papier polaroid du modele A, une image pour la
  //    carte du modele C — tout ce qui ne change jamais y est deja dessine.
  if (tpl.frame) {
    const f = tpl.frame;
    if (f.asset) {
      const bg = assets[f.asset];
      if (bg) ctx.drawImage(bg, f.x * scale, f.y * scale, f.w * scale, f.h * scale);
    } else if (f.fill) {
      ctx.fillStyle = f.fill;
      ctx.fillRect(f.x * scale, f.y * scale, f.w * scale, f.h * scale);
    }
  }

  // 2. Les photos du client
  for (const slot of tpl.slots) {
    drawSlot(ctx, slot, state.photos?.[slot.id], state.crops?.[slot.id], scale);
  }

  // 3. Les sur-couches (le trombone passe par-dessus les deux photos)
  for (const ov of tpl.overlays) {
    const img = assets[ov.asset];
    if (img) ctx.drawImage(img, ov.x * scale, ov.y * scale, ov.w * scale, ov.h * scale);
  }

  // 4. Les textes de marque, puis la phrase du client
  for (const t of tpl.staticTexts) drawInkText(ctx, t, scale, undefined, dark);
  if (tpl.editableText) {
    drawInkText(ctx, tpl.editableText, scale, state.caption ?? tpl.editableText.default, dark);
  }
}

/* ------------------------------------------------------------------ */
/*  Facteurs d'échelle                                                 */
/* ------------------------------------------------------------------ */

/** Échelle pour un aperçu dont le trim fait `previewW` pixels de large. */
function previewScale(tpl, previewW) {
  return previewW / tpl.trim.w;
}

/* ------------------------------------------------------------------ */
/*  Aperçu porté : le design composé sur le t-shirt                    */
/* ------------------------------------------------------------------ */
/**
 * Dessine le mockup Stanley/Stella puis y incruste le design, à l'échelle
 * physique réelle et à la place exacte où Printful l'imprimera.
 * Le client voit le vêtement, pas un visuel flottant.
 *
 * @param ctx     contexte 2D dimensionné à `size` × `size`
 * @param teeImg  image du mockup vierge (carrée)
 * @param size    côté du rendu, en pixels
 */
function renderMockup(ctx, teeImg, size, tpl, state, assets, dark = false) {
  ctx.clearRect(0, 0, size, size);
  if (teeImg) ctx.drawImage(teeImg, 0, 0, size, size);

  const { scale, offsetX, offsetY } = mockupTransform(size, tpl);

  ctx.save();
  ctx.translate(offsetX, offsetY);
  renderTemplate(ctx, tpl, state, { scale, assets, background: null, dark });
  ctx.restore();
}

/**
 * Transformation espace design → pixels du mockup.
 * Partagée par le rendu et par le pointage à la souris, pour que le client
 * attrape bien la photo qu'il voit sous son curseur.
 */
function mockupTransform(size, tpl) {
  const box = {
    x: MOCKUP_PRINT_BOX.x * size,
    y: MOCKUP_PRINT_BOX.y * size,
    w: MOCKUP_PRINT_BOX.w * size,
    h: MOCKUP_PRINT_BOX.h * size,
  };

  // La zone d'impression fait 12 po de large : on en déduit combien de
  // pixels d'écran valent un centimètre de tissu.
  const pxPerCm = box.w / (PRINT_AREA.widthIn / INCHES_PER_CM);
  const designW = tpl.printWidthCm * pxPerCm;
  const scale = designW / tpl.trim.w;

  // La hauteur sur le torse se regle une fois par produit dans Printful, et
  // rien n'oblige deux gabarits a partager la meme. Un design haut et etroit
  // et une carte large et basse ne tombent pas au meme endroit : chaque
  // gabarit peut donc porter sa propre valeur, mesuree sur le mockup.
  const haut = tpl.topOffsetRatio ?? PRINT_AREA.topOffsetRatio;

  return {
    scale,
    offsetX: box.x + (box.w - designW) / 2 - tpl.trim.x * scale,
    offsetY: box.y + box.h * haut - tpl.trim.y * scale,
  };
}

/** Résolution effective du design une fois imprimé à sa taille physique. */
function printDpi(tpl) {
  return tpl.trim.w / (tpl.printWidthCm / 2.54);
}

/**
 * Rendu du fichier destiné à Printful.
 *
 * Toile de 2000 × 2000 px, fond transparent, design à sa position native —
 * c'est-à-dire EXACTEMENT le gabarit des PSD d'origine, et donc celui du
 * fichier déjà déposé dans Printful.
 *
 * C'est ce qui rend le remplacement invisible : Printful conserve le cadrage
 * d'un fichier remplacé tant que les dimensions ne changent pas. En sortant
 * au gabarit natif, il n'y a jamais rien à recaler — le placement réglé une
 * fois sur le produit vaut pour toutes les commandes.
 *
 * La taille physique sur le vêtement n'est donc pas décidée ici : elle vient
 * du placement défini dans Printful. `printWidthCm` ne sert qu'à l'aperçu et
 * à l'évaluation de la qualité des photos, et doit refléter ce placement.
 */
function renderForPrint(makeCanvas, tpl, state, assets, dark = false) {
  const canvas = makeCanvas(DESIGN_SIZE, DESIGN_SIZE);
  const ctx = canvas.getContext('2d');
  renderTemplate(ctx, tpl, state, { scale: 1, assets, background: null, dark });
  return canvas;
}


/* ---- theme/ghorba-pod.js ---- */
/**
 * GHORBA CLUB — Personnalisateur POD (Web Component)
 * --------------------------------------------------
 * Deux modes, un seul code :
 *
 *  • Dans le thème — `data-form-id` et `data-variant-colours` sont fournis.
 *    Le coloris est lu depuis la variante choisie dans le sélecteur natif,
 *    et le composant se greffe sur le formulaire d'achat du thème sans le
 *    remplacer.
 *
 *  • En local — ni l'un ni l'autre. Le composant affiche ses propres
 *    pastilles de coloris et son propre bouton.
 *
 * Le fichier d'impression est fabriqué ici, dans le navigateur, par le même
 * moteur que l'aperçu : ce que le client voit est ce qui sera imprimé.
 *
 * UN SEUL APERÇU existe dans la page. Sur grand écran il va se loger dans la
 * grande image du produit ; sur mobile il reste dans le bloc, collé en haut
 * de l'écran pendant que le client descend les étapes. C'est le même élément
 * qui se déplace, jamais deux canevas concurrents.
 */



const SIZE = 900;     // rendu interne de l'aperçu quand il vit dans le bloc
const VIGNETTE = 300; // rendu interne des aperçus de modèle

/**
 * Le parcours mobile, dans l'ordre.
 *
 * Il dépend du produit : la carte de séjour n'a qu'un seul modèle, et on ne
 * fait pas choisir entre une chose et rien. Les titres viennent du gabarit,
 * pour qu'une fiche ne parle jamais de « ta phrase » là où le client remplit
 * son nom.
 */
function etapesPour(modeles, tpl) {
  const etapes = [];
  if (modeles.length > 1) etapes.push({ id: 'modele', titre: 'Choisis ton modèle' });
  etapes.push({ id: 'photos', titre: tpl.photoCount > 1 ? 'Tes photos' : 'Ta photo' });
  etapes.push({ id: 'phrase', titre: tpl.editableText.label });
  return etapes;
}

/** Sous cette largeur, on passe en parcours pas à pas. */
const MQ_MOBILE = '(max-width: 749px)';

/**
 * État conservé HORS du DOM, indexé par produit.
 * Le thème re-rend la section produit à chaque changement de variante :
 * sans ce cache, le client perdrait ses photos en choisissant sa taille.
 */
const SESSIONS = new Map();

/**
 * Un seul exemplaire actif par produit.
 * Le thème re-rend la fiche sans toujours détruire l'ancien nœud : sans ce
 * registre, deux composants finissaient greffés sur le même formulaire et
 * chacun préparait son visuel de son côté.
 */
const ACTIFS = new Map();

class GhorbaPod extends HTMLElement {
  connectedCallback() {
    this.base = this.dataset.assets || '/assets/';
    this.endpoint = this.dataset.endpoint || '';
    this.formId = this.dataset.formId || '';
    this.productId = this.dataset.productId || 'local';
    this.defaultColour = this.dataset.defaultColour || 'noir';

    try {
      this.variantColours = JSON.parse(this.dataset.variantColours || 'null');
    } catch {
      this.variantColours = null;
    }
    this.standalone = !this.variantColours || !Object.keys(this.variantColours).length;

    // Les gabarits offerts sur CE produit. Le t-shirt aux photos d'enfance
    // propose le polaroid et le duo ; la carte de séjour n'a qu'elle-même.
    // Le bloc de thème le lit du tag Shopify, et vaut A,B par défaut pour ne
    // rien changer aux fiches déjà en ligne.
    this.modeles = String(this.dataset.templates || 'A,B')
      .split(',').map(v => v.trim()).filter(id => TEMPLATES[id]);
    if (!this.modeles.length) this.modeles = Object.keys(TEMPLATES);

    if (!this.pret) {
      const saved = SESSIONS.get(this.productId);
      this.tplId = this.modeles.includes(saved?.tplId) ? saved.tplId : this.modeles[0];
      this.photos = saved?.photos || {};
      this.crops = saved?.crops || {};
      // Une phrase par défaut se propose ; un nom, jamais : personne ne veut
      // porter « NOM PRENOM » sur sa carte parce qu'il a oublié le champ.
      this.caption = saved?.caption ?? (this.tpl.editableText.required
        ? '' : this.tpl.editableText.default);
      this.ownColour = saved?.ownColour || this.defaultColour;
      this.etape = 0;
      this.tees = {};
      this.gabarits = {};
      this.exemples = {};
      this.build();
      this.pret = true;
    }

    // Tout ce qui suit se rejoue à chaque (re)connexion : le thème peut nous
    // déplacer ou recréer le formulaire sous nos pieds.
    this.prendreLaMain();
    this.surveillerApercu();
    this.attachForm();
    this.watchVariant();
    this.suivreLaLargeur();
    this.placerApercu();
    this.majEtapes();

    if (this.assetsCharges) this.draw();
    else this.loadAssets().then(() => { this.assetsCharges = true; this.draw(); });
  }

  /**
   * On rend la main proprement : plus de minuteur, plus d'écouteur sur le
   * formulaire. C'est ce qui évite qu'un exemplaire fantôme continue de
   * préparer des visuels après avoir été détaché.
   */
  disconnectedCallback() {
    this.seRetirer();
    this.rapatrierApercu();
    if (ACTIFS.get(this.productId) === this) ACTIFS.delete(this.productId);
  }

  /** Le clic sur l'aperçu, capté avant le thème. Une seule fois. */
  surveillerApercu() {
    if (this.ecouteApercu) return;
    this.ecouteApercu = true;
    window.addEventListener('click', this.onClicApercu, { capture: true });
  }

  seRetirer() {
    if (this.ecouteApercu) {
      window.removeEventListener('click', this.onClicApercu, { capture: true });
      this.ecouteApercu = false;
    }
    if (this.variantTimer) { clearInterval(this.variantTimer); this.variantTimer = null; }
    if (this.ecoute) {
      document.removeEventListener('click', this.onClick, { capture: true });
      document.removeEventListener('submit', this.onSubmit, { capture: true });
      this.ecoute = false;
    }
    this.form = null;
    if (this.mq) { this.mq.removeEventListener('change', this.onLargeur); this.mq = null; }
    this.apercuResize?.disconnect();
    this.apercuResize = null;
    document.documentElement.classList.remove('gp-pas-a-pas');
  }

  /** Le dernier exemplaire connecté est le seul à piloter le formulaire. */
  prendreLaMain() {
    const ancien = ACTIFS.get(this.productId);
    if (ancien && ancien !== this) ancien.seRetirer();
    ACTIFS.set(this.productId, this);
  }

  get tpl() { return TEMPLATES[this.tplId]; }

  get etapes() { return etapesPour(this.modeles, this.tpl); }

  /**
   * Le texte tel qu'il sera imprimé. Le nom de la carte passe en capitales,
   * comme sur le document : l'aperçu, le fichier d'impression et la ligne de
   * panier disent alors tous la même chose.
   */
  get texteImprime() {
    const t = this.caption.trim();
    return this.tpl.editableText.transform === 'uppercase' ? t.toUpperCase() : t;
  }

  get variant() {
    const id = this.form?.querySelector('[name="id"]')?.value;
    return (id && this.variantColours?.[id]) || null;
  }

  get colour() {
    if (this.standalone) return this.ownColour;
    const v = this.variant;
    if (typeof v === 'string') return v;   // ancien format, toléré
    return v?.c || this.defaultColour;
  }

  get variantTitle() {
    const v = this.variant;
    return (typeof v === 'object' && v?.t) ? v.t : '';
  }

  save() {
    SESSIONS.set(this.productId, {
      tplId: this.tplId, photos: this.photos, crops: this.crops,
      caption: this.caption, ownColour: this.ownColour,
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Greffe sur le formulaire d'achat du thème                         */
  /* ------------------------------------------------------------------ */
  /**
   * On intercepte le CLIC, pas la soumission.
   *
   * Le thème Fabric branche ses gestionnaires par attribut `on:submit`, au
   * moyen d'un écouteur délégué posé sur le document **en capture**, et
   * enregistré bien avant nos scripts : `component.js` est importé par
   * l'entête et le tiroir de panier, tout en haut de la page. Sa méthode
   * `handleSubmit` part donc toujours la première, et elle lit le formulaire
   * tel qu'il est à cet instant. Nos champs cachés étant encore vides, elle
   * ajoutait une ligne SANS personnalisation, puis notre resoumission en
   * ajoutait une seconde, celle-là complète. D'où les deux articles au
   * panier, l'un habillé, l'autre nu, pour un seul t-shirt.
   *
   * Le clic, lui, précède la soumission : l'annuler empêche celle-ci
   * d'exister. On prépare le visuel, puis on soumet nous-mêmes, une fois,
   * avec les champs déjà remplis.
   */
  attachForm() {
    if (!this.formId) return;
    const form = document.getElementById(this.formId);
    if (form && form !== this.form) {
      this.form = form;
      this.rattacherChamps();
    }
    if (this.ecoute) return;
    this.ecoute = true;
    document.addEventListener('click', this.onClick, { capture: true });
    document.addEventListener('submit', this.onSubmit, { capture: true });
  }

  /** Le visuel préparé est-il toujours attaché au formulaire ? */
  proprietesRemplies() {
    const cle = this.querySelector('[data-gp="printkey"]');
    return Boolean(cle && cle.value && cle.form === this.form);
  }

  /**
   * Rebranche les champs cachés sur le formulaire qui va être soumis.
   *
   * Nos champs vivent hors du formulaire et le désignent par son
   * identifiant. Quand le thème remplace le formulaire, au changement de
   * taille par exemple, il faut relancer cette résolution ; et si le
   * navigateur s'obstine, déposer une copie dans le formulaire lui-même.
   */
  rattacherChamps() {
    const form = this.form;
    if (!form) return;

    for (const el of this.querySelectorAll('input[data-gp]')) {
      if (el.form !== form) {
        const id = el.getAttribute('form');
        el.removeAttribute('form');
        if (id) el.setAttribute('form', id);
      }
      const miroirs = form.querySelectorAll(`input[data-gp-miroir="${el.dataset.gp}"]`);
      if (el.form === form) {
        miroirs.forEach(m => m.remove());   // la copie ferait doublon
        continue;
      }
      let miroir = miroirs[0];
      if (!miroir) {
        miroir = document.createElement('input');
        miroir.type = 'hidden';
        miroir.dataset.gpMiroir = el.dataset.gp;
        form.appendChild(miroir);
      }
      miroir.name = el.name;
      miroir.value = el.value;
    }
  }

  /** Est-ce le bouton d'achat de NOTRE fiche ? */
  boutonAchat(cible) {
    const bouton = cible?.closest?.('button[type="submit"], input[type="submit"], button[name="add"]');
    if (!bouton) return null;
    const form = bouton.form || bouton.closest('form');
    if (!form || form.getAttribute('id') !== this.formId) return null;
    this.form = form;
    return bouton;
  }

  onClick = (event) => {
    const bouton = this.boutonAchat(event.target);
    if (!bouton || bouton.disabled) return;

    // Visuel déjà préparé et bien accroché : on laisse le thème faire son
    // travail, sans rien intercepter.
    if (this.armed && this.proprietesRemplies()) return;

    // Sinon la soumission ne doit pas avoir lieu : annuler le clic la
    // supprime à la racine, avant que le thème n'en voie la couleur.
    event.preventDefault();
    event.stopPropagation();
    this.acheter(bouton);
  };

  /**
   * Le clic sur l'aperçu logé dans la galerie du thème.
   *
   * Là-haut, l'aperçu est posé en absolu par-dessus la photo produit. Sans
   * cette interception, le clic remontait à la galerie de Fabric, qui
   * ouvrait SA visionneuse : le client cliquait sur son visuel et voyait le
   * design placeholder.
   *
   * L'écouteur est posé sur `window`, pas sur `document`, et c'est
   * délibéré. Le thème pose le sien sur le document en capture, et il le
   * fait avant nous : sur un même nœud, en capture, c'est l'ordre
   * d'enregistrement qui décide, et nous perdions. La phase de capture,
   * elle, commence à `window` : un écouteur posé là passe forcément en
   * premier, quel que soit l'ordre de chargement des scripts.
   *
   * Il ne dépend pas du formulaire d'achat, contrairement à `onClick` :
   * agrandir son visuel n'a rien à voir avec l'acheter, et le personnalisateur
   * doit se comporter pareil sur la fiche et en local.
   */
  onClicApercu = (event) => {
    if (!this.tee?.classList.contains('gp-tee--galerie')) return;
    if (!this.tee.contains(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    // Un recadrage se termine lui aussi par un `click`. On ne l'agrandit
    // pas, mais on le retient quand même : sans cela, relâcher la photo
    // après l'avoir déplacée ouvrirait la visionneuse du thème.
    if (!this.aGlisse) this.openZoom();
  };

  /**
   * Filet de sécurité pour les soumissions qui ne viennent pas d'un clic,
   * au clavier par exemple. Le thème sera peut-être passé avant nous, mais
   * au moins la soumission native n'aboutit pas.
   */
  onSubmit = (event) => {
    const form = event.target;
    if (!form || form.getAttribute?.('id') !== this.formId) return;
    this.form = form;
    if (this.armed && this.proprietesRemplies()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    this.acheter(null);
  };

  /** Une seule soumission, avec le bouton comme déclencheur. */
  soumettre(bouton) {
    const form = this.form;
    if (!form) return;
    const b = (bouton && !bouton.disabled && (bouton.form || bouton.closest('form')) === form)
      ? bouton
      : form.querySelector('.add-to-cart-button, button[type="submit"], button[name="add"]');
    try {
      if (b && !b.disabled) form.requestSubmit(b);
      else form.requestSubmit();
    } catch {
      form.requestSubmit();
    }
  }

  /** Le geste d'achat, quel qu'en soit le déclencheur. */
  async acheter(bouton) {
    // Deuxième appui pendant qu'on travaille : on l'ignore. Sans cette
    // garde, deux préparations partaient en parallèle et chacune soumettait
    // le formulaire, d'où deux lignes de panier pour un seul t-shirt.
    if (this.enCours) return;

    if (!this.photosPretes()) {
      const manque = this.tpl.slots.filter(s => !this.photos[s.id]).length;
      this.allerA('photos');
      this.dire('erreur', manque > 1
        ? 'Il manque tes deux photos.'
        : 'Ajoute ta photo avant de commander.');
      this.querySelector('[data-photos]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (!this.textePret()) {
      this.allerA('phrase');
      this.dire('erreur', 'Écris le nom avant de commander.');
      this.querySelector('[data-caption]')?.focus();
      return;
    }

    if (this.armed && this.proprietesRemplies()) {
      this.soumettre(bouton);
      return;
    }

    this.enCours = true;
    this.busy(true);
    this.dire('travail', 'On prépare ton visuel…');

    try {
      const { previewUrl, printKey, apercuBlob } = await this.exportDesign();
      this.fillProperties(previewUrl, printKey);
      this.armed = true;
      this.garderApercu(previewUrl, apercuBlob);
      this.dire('succes', 'Ton visuel est enregistré. On t\'emmène au panier.');

      // On rend la main au thème AVANT de soumettre : son gestionnaire
      // abandonne si le bouton d'achat est désactivé.
      this.busy(false);
      this.soumettre(bouton);
      this.confirmerAjout(printKey);
    } catch (e) {
      console.error('[ghorba-pod]', e);
      this.dire('erreur', "Ton visuel n'a pas pu être enregistré. Réessaie dans un instant. "
              + "Si ça persiste, écris-nous et on le montera à la main.");
    } finally {
      this.enCours = false;
      this.busy(false);
    }
  }

  fillProperties(previewUrl, printKey) {
    const set = (key, value) => {
      const el = this.querySelector(`[data-gp="${key}"]`);
      if (el) el.value = value;
    };
    set('template', this.tpl.label);
    set('caption', this.texteImprime);
    set('preview', previewUrl);
    set('printkey', printKey);
    this.rattacherChamps();
  }

  /** Toute modification invalide le visuel déjà préparé. */
  disarm() {
    this.armed = false;
    this.save();
  }

  busy(on) {
    this.classList.toggle('gp-busy', on);
    // Le bouton du thème est réellement désactivé, pas seulement grisé :
    // c'est la deuxième barrière contre le double ajout au panier.
    const btn = this.form?.querySelector('.add-to-cart-button, button[type="submit"]');
    if (btn) {
      btn.disabled = on;
      btn.toggleAttribute('aria-busy', on);
    }
    const nav = this.querySelector('[data-suivant]');
    if (nav) nav.disabled = on;
    const own = this.querySelector('[data-buy]');
    if (own) {
      own.disabled = on;
      own.textContent = on ? 'Préparation…' : 'Ajouter au panier';
    }
  }

  /** Toutes les photos du gabarit sont déposées. */
  photosPretes() {
    return this.tpl.slots.every(s => this.photos[s.id]);
  }

  /**
   * Le texte est rempli — quand le gabarit l'exige. La phrase du polaroid a
   * un défaut qui vaut réponse ; le nom de la carte, non : une carte sans
   * nom n'est pas une carte.
   */
  textePret() {
    return !this.tpl.editableText.required || Boolean(this.caption.trim());
  }

  isComplete() {
    return this.photosPretes() && this.textePret();
  }

  /**
   * Le sélecteur de variante du thème modifie l'input caché par JavaScript,
   * sans émettre d'événement observable. On surveille donc la valeur, et on
   * se réaccroche au formulaire ou à l'aperçu s'ils ont été recréés.
   */
  watchVariant() {
    if (this.standalone || this.variantTimer) return;
    let last = null;
    this.variantTimer = setInterval(() => {
      this.attachForm();
      const apercuPerdu = !this.tee?.isConnected;
      this.placerApercu();
      const id = this.form?.querySelector('[name="id"]')?.value;
      if (id !== last || apercuPerdu) {
        last = id;
        this.disarm();
        this.majVariante();
        this.draw();
      }
    }, 300);
  }

  /* ------------------------------------------------------------------ */
  /*  L'aperçu unique et son déménagement                               */
  /* ------------------------------------------------------------------ */
  suivreLaLargeur() {
    if (this.mq) return;
    this.mq = window.matchMedia(MQ_MOBILE);
    this.onLargeur = () => { this.placerApercu(); this.majEtapes(); this.draw(); };
    this.mq.addEventListener('change', this.onLargeur);
  }

  get surMobile() { return this.mq ? this.mq.matches : false; }

  /**
   * Le vrai sujet de la page, c'est le t-shirt. Sur grand écran on va donc
   * poser l'aperçu dans la grande image du produit plutôt que de le confiner
   * à la colonne de droite. On ne touche pas au balisage du thème : on y
   * dépose notre élément, et on le reprend dès qu'on n'en a plus l'usage.
   */
  placerApercu() {
    if (!this.tee) return;
    const image = this.surMobile ? null : this.hoteGalerie();

    if (image) {
      const parent = image.parentElement;
      if (this.tee.parentElement !== parent) {
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        parent.appendChild(this.tee);
        this.tee.classList.add('gp-tee--galerie');
        this.classList.add('gp-apercu-galerie');
      }
      this.imageGalerie = image;
      this.callerSurImage();
      this.observerTaille();
    } else {
      this.imageGalerie = null;
      this.rapatrierApercu();
    }
    this.majVisibiliteApercu();
  }

  /** L'apercu occupe pile la boite de la photo du theme, au pixel pres. */
  callerSurImage() {
    const img = this.imageGalerie;
    if (!img || !this.tee.classList.contains('gp-tee--galerie')) return;
    this.tee.style.left = img.offsetLeft + 'px';
    this.tee.style.top = img.offsetTop + 'px';
    this.tee.style.width = img.offsetWidth + 'px';
    this.tee.style.height = img.offsetHeight + 'px';
  }

  rapatrierApercu() {
    const slot = this.querySelector('[data-stage]');
    if (!this.tee || !slot) return;
    if (this.tee.parentElement !== slot) slot.prepend(this.tee);
    this.tee.classList.remove('gp-tee--galerie');
    this.classList.remove('gp-apercu-galerie');
    this.tee.style.left = this.tee.style.top = '';
    this.tee.style.width = this.tee.style.height = '';
    this.apercuResize?.disconnect();
    this.apercuResize = null;
  }

  /**
   * L'image de la galerie du theme, et rien d'autre.
   *
   * On visait le conteneur avant, en le devinant. Selon la mise en page il
   * fait 1/1.25, il est centre, il porte plusieurs medias : l'apercu
   * s'affichait alors plus petit que la photo, ou debordait dessus. En se
   * calant sur l'image elle-meme, on occupe exactement sa place.
   */
  hoteGalerie() {
    const media = document.querySelector(
      '.product-media-container, .product-media, media-gallery, .media-gallery');
    return (media && media.querySelector('img')) || null;
  }

  /** Dans la galerie, l'aperçu épouse la boîte du thème : elle peut bouger. */
  observerTaille() {
    if (this.apercuResize || typeof ResizeObserver === 'undefined') return;
    // On surveille la PHOTO du theme, pas notre canevas : c'est elle qui
    // decide de la place, et se surveiller soi-meme tournait en boucle.
    this.apercuResize = new ResizeObserver(() => {
      this.callerSurImage();
      if (this.tee?.hasAttribute('hidden')) return;
      const r = this.tee.getBoundingClientRect();
      if (Math.round(r.width) === this.dernierW && Math.round(r.height) === this.dernierH) return;
      this.draw();
    });
    if (this.imageGalerie) this.apercuResize.observe(this.imageGalerie);
  }

  /**
   * Posé sur la photo du produit, l'aperçu ne se montre qu'une fois qu'il a
   * quelque chose à montrer : avant, la vraie photo du produit fait mieux
   * l'affaire. Dans le bloc, il est le sujet, donc toujours visible.
   */
  majVisibiliteApercu() {
    if (!this.tee) return;
    const dansGalerie = this.tee.classList.contains('gp-tee--galerie');
    const commence = Object.keys(this.photos).length > 0;
    this.tee.toggleAttribute('hidden', dansGalerie && !commence);
  }

  /* ------------------------------------------------------------------ */
  /*  Loupe plein écran                                                 */
  /* ------------------------------------------------------------------ */
  /**
   * Le t-shirt en grand, avec la personnalisation, qu'on peut fouiller.
   *
   * Le client vient vérifier le grain de SA photo : il doit pouvoir zoomer
   * dessus, mais aussi ressortir et regarder le vêtement entier.
   *
   * Le dessin est refait à chaque changement de zoom, à la résolution de
   * l'écran. Agrandir une image déjà calculée, comme on le faisait, revenait
   * à étirer des pixels : plus on zoomait, plus c'était flou, exactement là
   * où le client cherche à voir net.
   */
  openZoom() {
    if (!Object.keys(this.photos).length) return;

    const dlg = document.createElement('dialog');
    dlg.className = 'gp-zoom-dialog';
    dlg.innerHTML = `
      <button type="button" class="gp-zoom-close" aria-label="Fermer">&times;</button>
      <div class="gp-zoom-stage" data-stage><canvas></canvas></div>
      <div class="gp-zoom-barre">
        <button type="button" data-moins aria-label="Dézoomer">&minus;</button>
        <span data-niveau>100 %</span>
        <button type="button" data-plus aria-label="Zoomer">+</button>
        <button type="button" data-ajuster>Ajuster</button>
      </div>
      <p class="gp-zoom-note">Pince ou double-tape pour zoomer, fais glisser pour te
        déplacer sur le vêtement. Le grain que tu vois est celui de ta photo.</p>`;
    document.body.appendChild(dlg);

    const stage = dlg.querySelector('[data-stage]');
    const canvas = dlg.querySelector('canvas');
    const ctx = canvas.getContext('2d');
    const niveau = dlg.querySelector('[data-niveau]');

    const photos = {};
    for (const [id, v] of Object.entries(this.photos)) photos[id] = v.img;
    const etat = { photos, crops: this.crops, caption: this.caption };
    const dark = MOCKUPS[this.colour]?.dark ?? false;
    const tee = this.tees[this.colour];

    const MIN = 1, MAX = 6;
    let zoom = 1;
    let cx = 0.5, cy = 0.5;   // le point du vêtement au centre de l'écran
    let w = 0, h = 0, dpr = 1, ajuste = 0;
    let demande = null;

    const mesurer = () => {
      const r = stage.getBoundingClientRect();
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = Math.max(1, Math.round(r.width));
      h = Math.max(1, Math.round(r.height));
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ajuste = Math.min(w, h);   // le vêtement entier tient dans le cadre
    };

    /** On ne laisse pas le vêtement sortir du cadre. */
    const border = () => {
      const t = ajuste * zoom;
      if (t <= w) cx = 0.5;
      else cx = clamp(cx, w / (2 * t), 1 - w / (2 * t));
      if (t <= h) cy = 0.5;
      else cy = clamp(cy, h / (2 * t), 1 - h / (2 * t));
    };

    const dessiner = () => {
      demande = null;
      border();
      const t = ajuste * zoom;
      const ox = w / 2 - cx * t;
      const oy = h / 2 - cy * t;

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      ctx.save();
      ctx.translate(ox, oy);
      // Redessiné à la taille demandée : la photo du client est reprise à sa
      // source, pas agrandie depuis un rendu précédent.
      renderMockup(ctx, tee, t, this.tpl, etat, this.gabarits, dark);
      // Le fond clair se glisse derrière : renderMockup efface son cadre.
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = '#f0eee9';
      ctx.fillRect(0, 0, t, t);
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();

      niveau.textContent = Math.round(zoom * 100) + ' %';
      stage.dataset.zoome = String(zoom > 1.001);
    };

    const rafraichir = () => {
      if (demande) return;
      demande = requestAnimationFrame(dessiner);
    };

    /** Zoome en gardant sous le doigt le point qu'on vise. */
    const zoomerVers = (mx, my, vise) => {
      const z2 = clamp(vise, MIN, MAX);
      const t1 = ajuste * zoom;
      const ox = w / 2 - cx * t1;
      const oy = h / 2 - cy * t1;
      const px = (mx - ox) / t1;          // point vise, en fraction du vêtement
      const py = (my - oy) / t1;
      const t2 = ajuste * z2;
      cx = (w / 2 - (mx - px * t2)) / t2;
      cy = (h / 2 - (my - py * t2)) / t2;
      zoom = z2;
      rafraichir();
    };

    const local = (x, y) => {
      const r = stage.getBoundingClientRect();
      return { x: x - r.left, y: y - r.top };
    };

    stage.addEventListener('wheel', (ev) => {
      ev.preventDefault();
      const p = local(ev.clientX, ev.clientY);
      zoomerVers(p.x, p.y, zoom * (ev.deltaY < 0 ? 1.18 : 1 / 1.18));
    }, { passive: false });

    stage.addEventListener('dblclick', (ev) => {
      const p = local(ev.clientX, ev.clientY);
      zoomerVers(p.x, p.y, zoom > 1.2 ? MIN : 2.8);
    });

    // Un doigt fait glisser, deux doigts zooment.
    const doigts = new Map();
    let pince = null;
    const paire = () => [...doigts.values()];
    const ecart = () => {
      const [a, b] = paire();
      return Math.hypot(a.x - b.x, a.y - b.y) || 1;
    };
    const milieu = () => {
      const [a, b] = paire();
      return local((a.x + b.x) / 2, (a.y + b.y) / 2);
    };

    stage.addEventListener('pointerdown', (ev) => {
      stage.setPointerCapture(ev.pointerId);
      doigts.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
      if (doigts.size === 2) pince = { d: ecart(), z: zoom };
    });

    stage.addEventListener('pointermove', (ev) => {
      if (!doigts.has(ev.pointerId)) return;
      const avant = doigts.get(ev.pointerId);
      const dx = ev.clientX - avant.x;
      const dy = ev.clientY - avant.y;
      doigts.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });

      if (doigts.size >= 2 && pince) {
        const m = milieu();
        zoomerVers(m.x, m.y, pince.z * (ecart() / pince.d));
        return;
      }
      const t = ajuste * zoom;
      cx -= dx / t;
      cy -= dy / t;
      rafraichir();
    });

    const lacher = (ev) => {
      doigts.delete(ev.pointerId);
      if (doigts.size < 2) pince = null;
    };
    ['pointerup', 'pointercancel'].forEach(e => stage.addEventListener(e, lacher));

    const auCentre = (vise) => zoomerVers(w / 2, h / 2, vise);
    dlg.querySelector('[data-plus]').addEventListener('click', () => auCentre(zoom * 1.4));
    dlg.querySelector('[data-moins]').addEventListener('click', () => auCentre(zoom / 1.4));
    dlg.querySelector('[data-ajuster]').addEventListener('click', () => {
      zoom = MIN; cx = cy = 0.5; rafraichir();
    });

    const surTaille = () => { mesurer(); rafraichir(); };
    window.addEventListener('resize', surTaille);

    const fermer = () => {
      window.removeEventListener('resize', surTaille);
      if (demande) cancelAnimationFrame(demande);
      dlg.close();
      dlg.remove();
    };
    dlg.querySelector('.gp-zoom-close').addEventListener('click', fermer);
    dlg.addEventListener('cancel', fermer);

    dlg.showModal();
    mesurer();
    dessiner();
  }

  /* ------------------------------------------------------------------ */
  async loadAssets() {
    const faces = Object.values(FONTS).map(f =>
      new FontFace(f.family, `url(${this.base}${f.woff2}) format("woff2")`));
    const res = await Promise.allSettled(faces.map(f => f.load()));
    res.forEach((r, i) => { if (r.status === 'fulfilled') document.fonts.add(faces[i]); });

    // Les images du gabarit : le trombone du duo, le fond de la carte.
    // Elles se déclarent dans la spec, jamais ici.
    await Promise.all(TEMPLATE_ASSETS.map(async (nom) => {
      this.gabarits[nom] = await this.loadImg(this.base + nom).catch(() => null);
    }));
    for (const m of Object.values(MOCKUPS)) {
      this.tees[m.id] = await this.loadImg(this.base + m.asset).catch(() => null);
    }
    // Les photos d'exemple : légères, elles ne servent qu'aux vignettes.
    await Promise.all(EXAMPLE_ASSETS.map(async (f) => {
      this.exemples[f] = await this.loadImg(this.base + f).catch(() => null);
    }));
  }

  loadImg(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('image illisible'));
      img.src = src;
    });
  }

  /* ------------------------------------------------------------------ */
  build() {
    const modeles = this.modeles.map(id => TEMPLATES[id]).map(t => `
      <button type="button" class="gp-model" data-tpl="${t.id}" aria-pressed="${t.id === this.tplId}">
        <span class="gp-model-vue">
          <canvas data-vignette="${t.id}"></canvas>
          <span class="gp-model-tag" data-exemple>mockup</span>
        </span>
        <span class="gp-model-nom">${t.name}</span>
        <span class="gp-model-info">${t.note}</span>
      </button>`).join('');

    const colours = this.standalone ? `
      <div class="gp-colours">${Object.values(MOCKUPS).map(m => `
        <button type="button" class="gp-colour" data-c="${m.id}"
                aria-pressed="${m.id === this.ownColour}" aria-label="${m.label}"></button>`).join('')}
      </div>` : '';

    const ownBuy = this.formId ? '' : `
      <div class="gp-field"><button type="button" class="gp-buy" data-buy disabled>Ajouter au panier</button></div>`;

    const points = this.etapes.map((e, i) => `
      <li><button type="button" class="gp-point" data-point="${i}"
                  aria-current="${i === 0}">${i + 1}</button></li>`).join('');

    const hidden = [...this.querySelectorAll('input[data-gp]')];

    this.innerHTML = `
      <div class="gp-wrap">
        <div class="gp-stage" data-stage>
          <div class="gp-tee">
            <canvas></canvas>
            <span class="gp-model-tag gp-tee-tag" data-tee-exemple>mockup</span>
            <button type="button" class="gp-loupe" data-zoom hidden>Voir en grand</button>
          </div>
          <p class="gp-variante" data-variante></p>
          ${colours}
          <p class="gp-hint" data-hint></p>
        </div>

        <div class="gp-panel">
          <div class="gp-fil" data-fil>
            <ol class="gp-points">${points}</ol>
            <p class="gp-fil-titre" data-fil-titre></p>
          </div>

          ${this.modeles.length > 1 ? `
          <div class="gp-field" data-step="modele">
            <div class="gp-legend">Choisis ton modèle</div>
            <div class="gp-models">${modeles}</div>
            <p class="gp-sub" data-modele-note></p>
          </div>` : ''}

          <div class="gp-field" data-step="photos" data-photos>
            <div class="gp-legend" data-legend-photos>${this.tpl.photoCount > 1 ? 'Tes photos' : 'Ta photo'}</div>
          </div>

          <div class="gp-field" data-step="phrase">
            <div class="gp-legend" data-legend-phrase>${this.tpl.editableText.label}</div>
            <input class="gp-input" type="text" data-caption
                   maxlength="${this.tpl.editableText.maxChars}"
                   value="${this.caption.replace(/"/g, '&quot;')}"
                   placeholder="${this.tpl.editableText.default}"
                   ${this.tpl.editableText.transform === 'uppercase' ? 'data-majuscules' : ''}>
            <p class="gp-sub" data-count></p>
          </div>

          ${ownBuy}
          <p class="gp-message" data-message></p>

          <div class="gp-ajoute" data-ajoute hidden>
            <img class="gp-ajoute-vignette" data-ajoute-vignette alt="Ton visuel">
            <div class="gp-ajoute-texte">
              <b>C'est dans ton panier</b>
              <span class="gp-ajoute-detail" data-ajoute-detail></span>
              <p>Tu peux en composer un second, sur la même couleur ou une autre.
                 Il partira sur sa propre ligne, sans se mélanger avec celui-ci.</p>
            </div>
            <div class="gp-ajoute-actions">
              <button type="button" class="gp-next" data-encore>Personnaliser un autre</button>
              <a class="gp-ajoute-panier" href="/cart">Voir le panier</a>
            </div>
          </div>

        </div>

        <!-- Hors du panneau : sur telephone, le bouton doit venir APRES
             l'apercu, et la propriete order ne sait pas sortir un enfant de
             son parent. -->
        <div class="gp-nav" data-nav>
          <button type="button" class="gp-back" data-retour>Retour</button>
          <button type="button" class="gp-next" data-suivant>Suivant</button>
        </div>

        <ul class="gp-reassure">
          <li>Ce que tu vois est exactement ce qui sera imprimé.</li>
          <li>Ta photo sert à imprimer ta pièce, rien d'autre. On la garde
              le temps de la fabrication, puis on l'efface.</li>
          <li>Pièce imprimée à la commande, expédiée sous 7 à 10 jours.</li>
          <li>Comme elle est faite pour toi seul, elle n'est ni reprise ni
              échangée, sauf défaut évidemment.</li>
        </ul>
      </div>`;

    hidden.forEach(el => this.appendChild(el));

    this.tee = this.querySelector('.gp-tee');
    this.canvas = this.tee.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.loupe = this.tee.querySelector('[data-zoom]');
    this.badgeExemple = this.tee.querySelector('[data-tee-exemple]');

    this.querySelectorAll('[data-tpl]').forEach(b =>
      b.addEventListener('click', () => this.setTemplate(b.dataset.tpl)));
    this.querySelectorAll('[data-c]').forEach(b =>
      b.addEventListener('click', () => this.setColour(b.dataset.c)));
    this.loupe.addEventListener('click', () => this.openZoom());

    const cap = this.querySelector('[data-caption]');
    cap.addEventListener('input', () => {
      this.caption = cap.value;
      this.updateCount();
      // Le nom conditionne le passage à l'étape suivante : sans ce rappel,
      // le bouton resterait grisé jusqu'au prochain rendu.
      this.majEtapes();
      this.disarm();
      this.draw();
    });

    this.querySelector('[data-buy]')?.addEventListener('click', () => this.standaloneSubmit());
    this.querySelector('[data-encore]')?.addEventListener('click', () => this.recommencer());
    this.querySelector('[data-retour]').addEventListener('click', () => this.reculer());
    this.querySelector('[data-suivant]').addEventListener('click', () => this.avancer());
    this.querySelectorAll('[data-point]').forEach(b =>
      b.addEventListener('click', () => this.allerA(this.etapes[Number(b.dataset.point)].id)));

    this.updateCount();
    this.buildPhotos();
    this.bindDrag();
  }

  updateCount() {
    const t = this.tpl.editableText;
    this.querySelector('[data-count]').textContent =
      `${this.caption.length} / ${t.maxChars} caractères. `
      + (t.hint || 'La typo du club ne change pas.');
  }

  /** Un seul endroit pour parler au client, avec un ton par situation. */
  dire(ton, texte) {
    const el = this.querySelector('[data-message]');
    if (!el) return;
    el.textContent = texte || '';
    el.dataset.ton = texte ? ton : '';
  }

  /* ------------------------------------------------------------------ */
  /*  Parcours pas à pas (mobile)                                       */
  /* ------------------------------------------------------------------ */
  /**
   * 80 % du trafic arrive au doigt. Sur un écran de téléphone, tout empiler
   * noie le client : on ne montre qu'une étape à la fois, l'aperçu reste
   * collé en haut, et le bouton d'achat n'apparaît qu'à la fin. Sur grand
   * écran, rien de tout ça : tout est visible d'un coup.
   */
  majEtapes() {
    const mobile = this.surMobile;
    this.classList.toggle('gp-etapes', mobile);
    // C'est le JavaScript qui pose ce drapeau, jamais le CSS seul : si le
    // script tombe, le bouton d'achat du thème reste visible.
    document.documentElement.classList.toggle('gp-pas-a-pas', mobile);

    const etapes = this.etapes;
    const derniere = this.etape === etapes.length - 1;
    this.classList.toggle('gp-fin', mobile && derniere);

    etapes.forEach((e, i) => {
      const el = this.querySelector(`[data-step="${e.id}"]`);
      if (el) el.hidden = mobile && i !== this.etape;
      const pt = this.querySelector(`[data-point="${i}"]`);
      if (pt) {
        pt.setAttribute('aria-current', String(i === this.etape));
        pt.dataset.fait = String(i < this.etape);
      }
    });

    const titre = this.querySelector('[data-fil-titre]');
    if (titre) {
      titre.textContent = `Étape ${this.etape + 1} sur ${etapes.length} · ${etapes[this.etape].titre}`;
    }

    const retour = this.querySelector('[data-retour]');
    const suivant = this.querySelector('[data-suivant]');
    if (retour) retour.hidden = this.etape === 0;
    if (suivant) {
      suivant.textContent = derniere ? 'Ajouter au panier' : 'Suivant';
      suivant.classList.toggle('gp-next--achat', derniere);
      // On ne laisse pas quitter une étape les mains vides : c'est tout
      // l'objet du produit. Chaque étape garde la sienne — sans quoi le nom,
      // demandé en dernier, bloquerait déjà le bouton des photos.
      const ici = etapes[this.etape].id;
      const sansPhoto = ici === 'photos' && !this.photosPretes();
      const sansTexte = ici === 'phrase' && !this.textePret();
      const bloque = sansPhoto || sansTexte;
      suivant.disabled = bloque || Boolean(this.enCours);
      suivant.title = sansTexte ? this.tpl.editableText.label
        : sansPhoto ? (this.tpl.photoCount > 1 ? 'Ajoute tes deux photos' : 'Ajoute ta photo')
        : '';
    }
  }

  allerA(id) {
    const i = this.etapes.findIndex(e => e.id === id);
    if (i < 0 || i === this.etape) return;
    this.etape = i;
    this.majEtapes();
  }

  avancer() {
    if (this.etape < this.etapes.length - 1) {
      this.etape += 1;
      this.majEtapes();
      this.querySelector('[data-fil]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    // Dernière étape : c'est notre bouton qui déclenche l'achat, puisque
    // celui du thème est masqué pendant le parcours. On passe par le même
    // chemin que le clic, jamais par une soumission directe : le thème
    // partirait devant nous avec un formulaire encore vide.
    if (this.form) this.acheter(null);
    else this.standaloneSubmit();
  }

  reculer() {
    if (this.etape === 0) return;
    this.etape -= 1;
    this.majEtapes();
    this.querySelector('[data-fil]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /** Rappel de la variante choisie, avec un raccourci pour la changer. */
  majVariante() {
    const el = this.querySelector('[data-variante]');
    if (!el) return;
    const t = this.variantTitle;
    if (!t) { el.textContent = ''; el.dataset.titre = ''; return; }
    if (el.dataset.titre === t) return;
    el.dataset.titre = t;
    el.innerHTML = `<span>${t}</span><button type="button" data-vers-variantes>changer</button>`;
    el.querySelector('[data-vers-variantes]').addEventListener('click', () => {
      document.querySelector('variant-picker, .variant-picker, [data-block-type="variant-picker"]')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ------------------------------------------------------------------ */
  buildPhotos() {
    const host = this.querySelector('[data-photos]');
    host.querySelectorAll('.gp-photo').forEach(n => n.remove());

    this.tpl.slots.forEach((slot, i) => {
      const p = this.photos[slot.id];
      const crop = this.crops[slot.id] || { zoom: 1, dx: 0, dy: 0 };
      const el = document.createElement('div');
      el.className = 'gp-photo' + (p ? ' is-ok' : '');

      const remplie = `
        <div class="gp-file">
          <img src="${p?.url}" alt="">
          <span class="gp-file-nom">
            <b>Photo bien reçue</b>
            <small>${p?.name || ''} · ${p?.w}×${p?.h} px</small>
          </span>
          <button type="button" data-remove>Changer</button>
        </div>
        <div class="gp-range">
          <label>Zoom</label>
          <input type="range" min="1" max="2.5" step="0.01" value="${crop.zoom}" data-zoom-range>
        </div>
        <p class="gp-quality" data-level="${p?.q.level}">${p?.q.message}</p>
        <input type="file" accept="image/*" data-file>`;

      const vide = `
        <button type="button" class="gp-add" data-add>
          <b>${this.tpl.photoCount > 1 ? `Photo ${i + 1}` : 'Choisir une photo'}</b>
          <small>Un scan, un tirage photographié, une capture, tout passe.</small>
        </button>
        <input type="file" accept="image/*" data-file>`;

      el.innerHTML = p ? remplie : vide;
      host.appendChild(el);

      const input = el.querySelector('[data-file]');
      const add = el.querySelector('[data-add]');

      if (add) {
        add.addEventListener('click', () => input.click());
        ['dragenter', 'dragover'].forEach(e => add.addEventListener(e, ev => {
          ev.preventDefault(); add.classList.add('is-over');
        }));
        ['dragleave', 'drop'].forEach(e => add.addEventListener(e, ev => {
          ev.preventDefault(); add.classList.remove('is-over');
        }));
        add.addEventListener('drop', ev => {
          const f = ev.dataTransfer && ev.dataTransfer.files[0];
          if (f) this.acceptFile(slot.id, f);
        });
      }

      input.addEventListener('change', () => {
        if (input.files[0]) this.acceptFile(slot.id, input.files[0]);
      });
      el.querySelector('[data-remove]')?.addEventListener('click', () => input.click());
      el.querySelector('[data-zoom-range]')?.addEventListener('input', (ev) => {
        const prev = this.crops[slot.id] || { dx: 0, dy: 0 };
        this.crops[slot.id] = { ...prev, zoom: Number(ev.target.value) };
        this.disarm();
        this.draw();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  async acceptFile(slotId, file) {
    this.dire('', '');

    if (!file.type.startsWith('image/')) {
      return this.dire('erreur', "Ce fichier n'est pas une image.");
    }
    if (file.size > 25 * 1024 * 1024) {
      return this.dire('erreur', 'Photo trop lourde : 25 Mo maximum.');
    }

    const url = URL.createObjectURL(file);
    let img;
    try {
      img = await this.loadImg(url);
    } catch {
      URL.revokeObjectURL(url);
      // Cas fréquent : photo HEIC sortie d'un iPhone, non décodée ici.
      return this.dire('erreur', "Impossible de lire cette photo. Si elle vient d'un iPhone "
        + "(format HEIC), ouvre-la puis enregistre-la en JPEG avant de la déposer.");
    }

    if (this.photos[slotId]) URL.revokeObjectURL(this.photos[slotId].url);
    const slot = this.tpl.slots.find(s => s.id === slotId);
    this.photos[slotId] = {
      img, file, url, name: file.name,
      w: img.naturalWidth, h: img.naturalHeight,
      q: assessPhoto(this.tpl, slot, img.naturalWidth, img.naturalHeight),
    };
    this.crops[slotId] = { zoom: 1, dx: 0, dy: 0 };
    this.disarm();
    this.buildPhotos();
    this.draw();

    this.dire('succes', this.photosPretes()
      ? 'Photo reçue. Regarde le résultat sur le t-shirt.'
      : 'Première photo reçue. Ajoute la seconde.');
  }

  /* ------------------------------------------------------------------ */
  /*  Recadrage à la souris et au doigt                                 */
  /* ------------------------------------------------------------------ */
  bindDrag() {
    let active = null;

    // L'aperçu change de taille selon l'endroit où il vit : on repart donc
    // toujours de la géométrie du dernier rendu, jamais d'une constante.
    const toDesign = (ev) => {
      const r = this.canvas.getBoundingClientRect();
      const v = this.vue || { w: SIZE, h: SIZE, side: SIZE, ox: 0, oy: 0 };
      const { scale, offsetX, offsetY } = mockupTransform(v.side, this.tpl);
      const cx = ((ev.clientX - r.left) / r.width) * v.w - v.ox;
      const cy = ((ev.clientY - r.top) / r.height) * v.h - v.oy;
      return { x: (cx - offsetX) / scale, y: (cy - offsetY) / scale, scale, r, v };
    };

    const slotAt = (ev) => {
      const { x, y } = toDesign(ev);
      return [...this.tpl.slots].reverse().find(s =>
        this.photos[s.id] && x >= s.x && x <= s.x + s.w && y >= s.y && y <= s.y + s.h);
    };

    this.canvas.addEventListener('pointermove', ev => {
      if (!active) {
        this.tee.dataset.grab = String(Boolean(slotAt(ev)));
        return;
      }
      // Sur écran tactile, on empêche la page de défiler pendant le geste.
      if (ev.pointerType !== 'mouse') ev.preventDefault();
      // Au-delà de trois pixels, c'est un recadrage, pas un clic. Le
      // `click` qui suivra ne doit donc pas ouvrir l'agrandissement.
      if (Math.abs(ev.clientX - active.px) > 3 || Math.abs(ev.clientY - active.py) > 3) {
        this.aGlisse = true;
      }
      const { r, scale, v } = toDesign(ev);
      const k = (v.w / r.width) / scale;
      const { slot } = active;
      const dx = (ev.clientX - active.px) * k;
      const dy = (ev.clientY - active.py) * k;
      this.crops[slot.id] = {
        ...active.crop,
        dx: clamp(active.crop.dx - (dx / slot.w) * 2, -1, 1),
        dy: clamp(active.crop.dy - (dy / slot.h) * 2, -1, 1),
      };
      // Pendant le geste on ne redessine que l'apercu : refaire les vignettes
      // et tout le panneau a chaque mouvement hacherait le recadrage au doigt.
      this.dessinerApercu();
    });

    this.canvas.addEventListener('pointerdown', ev => {
      this.aGlisse = false;
      const slot = slotAt(ev);
      if (!slot) return;
      active = { slot, px: ev.clientX, py: ev.clientY,
        crop: { ...(this.crops[slot.id] || { zoom: 1, dx: 0, dy: 0 }) } };
      this.canvas.setPointerCapture(ev.pointerId);
      this.tee.classList.add('is-dragging');
    });

    ['pointerup', 'pointercancel'].forEach(e =>
      this.canvas.addEventListener(e, () => {
        if (active) { this.disarm(); this.draw(); }
        active = null;
        this.tee.classList.remove('is-dragging');
      }));
  }

  /* ------------------------------------------------------------------ */
  setTemplate(id) {
    if (id === this.tplId) return;
    this.tplId = id;
    this.querySelectorAll('[data-tpl]').forEach(b =>
      b.setAttribute('aria-pressed', String(b.dataset.tpl === id)));

    for (const slot of this.tpl.slots) {
      const p = this.photos[slot.id];
      if (p) p.q = assessPhoto(this.tpl, slot, p.w, p.h);
    }

    const t = this.tpl.editableText;
    const cap = this.querySelector('[data-caption]');
    cap.maxLength = t.maxChars;
    cap.placeholder = t.default;
    cap.toggleAttribute('data-majuscules', t.transform === 'uppercase');
    const legende = this.querySelector('[data-legend-phrase]');
    if (legende) legende.textContent = t.label;
    const lp = this.querySelector('[data-legend-photos]');
    if (lp) lp.textContent = this.tpl.photoCount > 1 ? 'Tes photos' : 'Ta photo';

    this.updateCount();
    this.disarm();
    this.buildPhotos();
    this.draw();

    if (this.tpl.photoCount > 1 && !this.photosPretes()) {
      this.dire('info', 'Ce modèle demande deux photos.');
    } else {
      this.dire('', '');
    }
  }

  setColour(c) {
    if (c === this.ownColour) return;
    this.ownColour = c;
    this.querySelectorAll('[data-c]').forEach(b =>
      b.setAttribute('aria-pressed', String(b.dataset.c === c)));
    this.disarm();
    this.draw();
  }

  /* ------------------------------------------------------------------ */
  /**
   * @param {boolean} contenir  vrai : le vêtement tient entier dans le cadre,
   *   quitte à laisser des marges. Faux : il déborde pour remplir.
   */
  paint(canvas, ctx, w, h, tee, state, dark, contenir = false) {
    if (w < 2 || h < 2) return;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    // Le mockup est carre, le cadre du theme ne l'est pas. Dans la galerie
    // Fabric, le cadre fait 1/1.25 et les photos y sont posees en
    // « contain » : deborder recadrerait le t-shirt plus large que sa propre
    // photo produit, manches coupees. On se cale donc sur le theme.
    const side = contenir ? Math.min(w, h) : Math.max(w, h);
    const ox = (w - side) / 2;
    const oy = (h - side) / 2;
    ctx.clearRect(0, 0, w, h);
    ctx.save();
    ctx.translate(ox, oy);
    renderMockup(ctx, tee, side, this.tpl, state, this.gabarits, dark);
    ctx.restore();

    // Le pointage à la souris rejoue exactement cette transformation.
    if (canvas === this.canvas) this.vue = { w, h, side, ox, oy };
  }

  /**
   * Les deux modèles, montrés avec les photos du client dès qu'il en a une,
   * et avec un exemple tant qu'il n'a rien déposé. Un cadre vide ne dit rien
   * du produit : c'est surtout vrai du duo, dont le trombone est invisible
   * sans photos.
   */
  drawVignettes(tee, dark) {
    const dispo = Object.values(this.photos);
    const surExemple = dispo.length === 0;

    for (const tpl of Object.values(TEMPLATES)) {
      const c = this.querySelector(`[data-vignette="${tpl.id}"]`);
      if (!c) continue;
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      c.width = VIGNETTE * dpr;
      c.height = VIGNETTE * dpr;
      const x = c.getContext('2d');
      x.setTransform(dpr, 0, 0, dpr, 0, 0);

      const photos = {};
      let crops, caption;
      if (surExemple) {
        for (const [id, f] of Object.entries(tpl.example.photos)) photos[id] = this.exemples[f];
        crops = tpl.example.crops;
        caption = tpl.example.caption;
      } else {
        // On réutilise les photos déposées, même si elles l'ont été pour
        // l'autre modèle : le client se projette immédiatement.
        tpl.slots.forEach((s, i) => { if (dispo[i]) photos[s.id] = dispo[i].img; });
        crops = this.crops;
        caption = this.caption;
      }

      const grand = SIZE;
      const { scale, offsetX, offsetY } = mockupTransform(grand, tpl);
      const dx = offsetX + tpl.trim.x * scale;
      const dy = offsetY + tpl.trim.y * scale;
      const dw = tpl.trim.w * scale, dh = tpl.trim.h * scale;
      const cote = Math.max(dw, dh) * 1.9;
      const k = VIGNETTE / cote;

      x.fillStyle = dark ? '#111111' : '#f0eee9';
      x.fillRect(0, 0, VIGNETTE, VIGNETTE);
      x.save();
      x.translate(-(dx + dw / 2 - cote / 2) * k, -(dy + dh / 2 - cote / 2) * k);
      x.scale(k, k);
      renderMockup(x, tee, grand, tpl, { photos, crops, caption },
        this.gabarits, dark);
      x.restore();
    }

    this.querySelectorAll('[data-exemple]').forEach(el => { el.hidden = !surExemple; });
    const note = this.querySelector('[data-modele-note]');
    if (note) {
      note.textContent = surExemple
        ? 'Mockups. Tes photos prendront leur place dès que tu les auras déposées.'
        : '';
    }
  }

  /** Le vêtement porté, seul. C'est ce qui bouge à chaque frame du recadrage. */
  dessinerApercu() {
    const colour = this.colour;
    const tee = this.tees[colour];
    const dark = MOCKUPS[colour]?.dark ?? false;

    // Tant que le client n'a rien depose, on lui montre le modele porte
    // plutot qu'un cadre vide, signale comme un exemple.
    const surExemple = Object.keys(this.photos).length === 0;
    const photos = {};
    let state;
    if (surExemple) {
      const ex = this.tpl.example;
      for (const [id, f] of Object.entries(ex.photos)) photos[id] = this.exemples[f];
      state = { photos, crops: ex.crops, caption: ex.caption };
    } else {
      for (const [k, v] of Object.entries(this.photos)) photos[k] = v.img;
      state = { photos, crops: this.crops, caption: this.caption };
    }
    this.badgeExemple?.toggleAttribute('hidden', !surExemple);

    this.majVisibiliteApercu();

    // L'aperçu épouse la boîte du thème quand il vit dans la galerie ; dans
    // le bloc, il garde son rendu carré à taille fixe, mis à l'échelle en CSS.
    if (this.tee.classList.contains('gp-tee--galerie')) {
      const r = this.tee.getBoundingClientRect();
      this.dernierW = Math.round(r.width);
      this.dernierH = Math.round(r.height);
      // Le theme cadre ses photos en « cover » ou en « contain » selon son
      // reglage : on lit le sien plutot que d'en choisir un, sinon l'apercu
      // ne se comporte pas comme la photo qu'il remplace.
      const contenir = this.imageGalerie
        && getComputedStyle(this.imageGalerie).objectFit === 'contain';
      this.paint(this.canvas, this.ctx, this.dernierW, this.dernierH, tee, state, dark, contenir);
    } else {
      // Le vetement entier, jamais recadre : on le borne en hauteur par le
      // CSS plutot que de lui couper les epaules et l'ourlet.
      this.dernierW = this.dernierH = SIZE;
      this.paint(this.canvas, this.ctx, SIZE, SIZE, tee, state, dark);
    }
    return { tee, dark };
  }

  draw() {
    const { tee, dark } = this.dessinerApercu();
    this.drawVignettes(tee, dark);

    const commence = Object.keys(this.photos).length > 0;
    const rempli = this.tpl.slots.filter(s => this.photos[s.id]).length;
    // Court : sur telephone ce conseil partage sa ligne avec la variante,
    // et une phrase qui passe a la ligne annule la place gagnee.
    this.querySelector('[data-hint]').textContent = rempli
      ? 'Fais glisser pour recadrer.'
      : 'Mockup. Dépose ta photo pour voir la tienne.';
    this.loupe.hidden = !commence;

    const own = this.querySelector('[data-buy]');
    if (own) own.disabled = !this.isComplete();

    this.majVariante();
    this.majEtapes();
    this.save();
  }

  /* ------------------------------------------------------------------ */
  /*  Ce qui se passe une fois ajouté au panier                         */
  /* ------------------------------------------------------------------ */
  /**
   * Met une copie de l'aperçu de côté, indexée par son adresse.
   *
   * Le panier va chercher cette image sur notre serveur de rendu, qui peut
   * mettre plusieurs secondes à répondre à froid : la ligne restait alors
   * longtemps illustrée par la photo du produit, c'est-à-dire par le design
   * de quelqu'un d'autre. Avec cette copie, la vignette est immédiate sur
   * toute la visite.
   */
  async garderApercu(url, blob) {
    if (!url || !blob) return;
    try {
      const img = await this.loadImg(URL.createObjectURL(blob));

      // Deux images : le vetement entier pour l'agrandissement, et un
      // rapproche sur le design pour la vignette. Dans une ligne de panier
      // large de 110 px, le t-shirt entier ne laisse rien deviner.
      const entier = this.reduire(img, 560);
      const rapproche = this.rapprocher(img, 420);
      URL.revokeObjectURL(img.src);

      this.ranger('ghorba-pod:apercu:' + url, entier);
      this.ranger('ghorba-pod:vignette:' + url, rapproche);
    } catch {
      // Sans copie locale, le panier ira simplement chercher l'image en ligne.
    }
  }

  ranger(cle, valeur) {
    try {
      sessionStorage.setItem(cle, valeur);
    } catch {
      // Quota atteint : on fait de la place et on retente une fois.
      for (const k of Object.keys(sessionStorage)) {
        if (k.startsWith('ghorba-pod:')) sessionStorage.removeItem(k);
      }
      try { sessionStorage.setItem(cle, valeur); } catch { /* tant pis */ }
    }
  }

  reduire(img, cote) {
    const c = document.createElement('canvas');
    c.width = c.height = cote;
    const x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(img, 0, 0, cote, cote);
    return c.toDataURL('image/jpeg', 0.82);
  }

  /**
   * Recadre l'apercu sur la zone imprimee, en gardant assez de tissu autour
   * pour qu'on reconnaisse encore un t-shirt.
   */
  rapprocher(img, cote) {
    const S = img.naturalWidth || 700;
    const tpl = this.tpl;
    const { scale, offsetX, offsetY } = mockupTransform(S, tpl);
    const w = tpl.trim.w * scale;
    const h = tpl.trim.h * scale;
    const cx = offsetX + (tpl.trim.x + tpl.trim.w / 2) * scale;
    const cy = offsetY + (tpl.trim.y + tpl.trim.h / 2) * scale;
    const fenetre = Math.min(S, Math.max(w, h) * 2.1);
    const sx = clamp(cx - fenetre / 2, 0, S - fenetre);
    const sy = clamp(cy - fenetre / 2, 0, S - fenetre);

    const c = document.createElement('canvas');
    c.width = c.height = cote;
    const x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(img, sx, sy, fenetre, fenetre, 0, 0, cote, cote);
    return c.toDataURL('image/jpeg', 0.82);
  }

  /**
   * On n'annonce l'ajout qu'une fois la ligne réellement dans le panier.
   * Le thème fait l'ajout en AJAX de son côté : on le vérifie plutôt que de
   * le supposer, sinon un échec réseau afficherait quand même « ajouté ».
   */
  async confirmerAjout(printKey) {
    for (let essai = 0; essai < 4; essai++) {
      await new Promise(r => setTimeout(r, 400 + essai * 300));
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(r => r.json());
        const ligne = (cart.items || []).find(i => i.properties && i.properties._print_key === printKey);
        if (ligne) { this.montrerAjout(ligne); return; }
      } catch { /* on retente */ }
    }
  }

  montrerAjout(ligne) {
    const panneau = this.querySelector('[data-ajoute]');
    if (!panneau) return;

    const vignette = panneau.querySelector('[data-ajoute-vignette]');
    if (vignette) {
      const url = ligne.properties && ligne.properties._apercu;
      let local = null;
      try {
        local = url && (sessionStorage.getItem('ghorba-pod:vignette:' + url)
                     || sessionStorage.getItem('ghorba-pod:apercu:' + url));
      } catch { /* stockage indisponible */ }
      if (local || url) vignette.src = local || url;
    }
    const detail = panneau.querySelector('[data-ajoute-detail]');
    if (detail) {
      const phrase = (ligne.properties && ligne.properties['Ta phrase']) || '';
      detail.textContent = [ligne.variant_title, phrase].filter(Boolean).join(' · ');
    }

    panneau.hidden = false;
    this.classList.add('gp-termine');
    this.dire('', '');
    panneau.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * Repart de zéro pour une seconde pièce.
   *
   * Le point délicat : la commande précédente est déjà partie au panier avec
   * sa propre clé d'impression. Tout vider ici, cache compris, garantit que
   * la suivante ne réutilisera aucun morceau de la première.
   */
  recommencer() {
    for (const p of Object.values(this.photos)) {
      if (p && p.url) URL.revokeObjectURL(p.url);
    }
    this.photos = {};
    this.crops = {};
    this.caption = this.tpl.editableText.required ? '' : this.tpl.editableText.default;
    this.armed = false;
    this.etape = 0;
    SESSIONS.delete(this.productId);

    const cap = this.querySelector('[data-caption]');
    if (cap) cap.value = this.caption;

    // Les champs caches portaient encore la piece precedente. Les vider
    // garantit qu'aucune soumission ne peut repartir avec son visuel.
    this.fillProperties('', '');
    const cap2 = this.querySelector('[data-gp="template"]');
    if (cap2) cap2.value = '';

    const panneau = this.querySelector('[data-ajoute]');
    if (panneau) panneau.hidden = true;
    this.classList.remove('gp-termine');

    this.updateCount();
    this.buildPhotos();
    this.draw();
    this.dire('info', 'À toi de jouer pour la seconde. Elle partira sur sa propre ligne de panier.');
    this.querySelector('[data-fil]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ------------------------------------------------------------------ */
  /*  Fabrication du fichier d'impression, ici même                     */
  /* ------------------------------------------------------------------ */
  async buildPrintFile() {
    const make = (w, h) => {
      const c = document.createElement('canvas');
      c.width = w; c.height = h; return c;
    };
    const photos = {};
    for (const [k, v] of Object.entries(this.photos)) photos[k] = v.img;
    const dark = MOCKUPS[this.colour]?.dark ?? false;

    const canvas = renderForPrint(make, this.tpl,
      { photos, crops: this.crops, caption: this.caption },
      this.gabarits, dark);

    const blob = await new Promise((res, rej) =>
      canvas.toBlob(b => b ? res(b) : rej(new Error('encodage impossible')), 'image/png'));

    // Un canevas de 2000 x 2000 pese 16 Mo en memoire vive. Sur un telephone
    // d'entree de gamme, le garder pendant l'encodage de l'apercu suffit a
    // faire tomber l'onglet : on le libere des qu'il a servi.
    canvas.width = canvas.height = 0;

    // Sans résolution déclarée, Printful suppose 72 dpi et place le design
    // quatre fois trop grand.
    const stamped = setPngDpi(new Uint8Array(await blob.arrayBuffer()), 300);
    return new Blob([stamped], { type: 'image/png' });
  }

  async buildPreview() {
    const size = 700;
    const c = document.createElement('canvas');
    c.width = size; c.height = size;
    const ctx = c.getContext('2d');
    const dark = MOCKUPS[this.colour]?.dark ?? false;

    // L'aperçu du panier montre le vêtement, pas le fichier : c'est ce que
    // le client a choisi, et ce qu'il veut retrouver dans son panier.
    const photos = {};
    for (const [k, v] of Object.entries(this.photos)) photos[k] = v.img;
    renderMockup(ctx, this.tees[this.colour], size, this.tpl,
      { photos, crops: this.crops, caption: this.caption },
      this.gabarits, dark);

    return new Promise((res, rej) =>
      c.toBlob(b => b ? res(b) : rej(new Error('aperçu impossible')), 'image/jpeg', 0.85));
  }

  async exportDesign() {
    // L'un apres l'autre, pas en parallele : deux encodages PNG simultanes
    // font deux pics memoire au meme instant, et c'est le telephone qui paie.
    const design = await this.buildPrintFile();
    const preview = await this.buildPreview();

    const fd = new FormData();
    fd.append('template', this.tplId);
    fd.append('colour', this.colour);
    fd.append('caption', this.texteImprime);
    fd.append('crops', JSON.stringify(this.crops));
    fd.append('variantTitle', this.variantTitle);
    fd.append('variantId', this.form?.querySelector('[name="id"]')?.value || '');
    fd.append('productId', this.productId);
    fd.append('design', design, 'design.png');
    fd.append('preview', preview, 'apercu.jpg');
    for (const slot of this.tpl.slots) {
      fd.append(slot.id, this.photos[slot.id].file, this.photos[slot.id].name);
    }

    const res = await fetch(this.endpoint, { method: 'POST', body: fd });
    if (!res.ok) throw new Error(await res.text());
    // On rend aussi l'apercu deja calcule : le panier s'en sert pour
    // afficher la vignette sans attendre le serveur de rendu.
    return { ...(await res.json()), apercuBlob: preview };
  }

  async standaloneSubmit() {
    if (this.enCours) return;
    this.enCours = true;
    this.busy(true);
    this.dire('travail', 'On prépare ton visuel…');
    try {
      const { previewUrl, printKey } = await this.exportDesign();
      this.fillProperties(previewUrl, printKey);
      this.dire('succes', 'Visuel enregistré.');
      console.info('[ghorba-pod]', { previewUrl, printKey });
    } catch (e) {
      console.error('[ghorba-pod]', e);
      this.dire('erreur', "Le service de rendu n'a pas répondu.");
    } finally {
      this.enCours = false;
      this.busy(false);
    }
  }
}

customElements.define('ghorba-pod', GhorbaPod);

})();
